module.exports = __webpack_public_path__ + "img/icon-book.356ba9c9.svg";